import React from "react"
import "./buttonActionsHL.css"

const ButtonActionsHL = (props) => {
    let {
        nameBtn,
        onClickBtn,
        showIcon,
        icon,
        selected
    } = props

    return(
        <button
            {...props}
            type="button"
            className={(selected) ? "buttonActionsHL-btn-selected" : "buttonActionsHL-btn"}
            onClick={onClickBtn}
        >
            { showIcon && (
                    <img src={icon} className="buttonActionsHL-icon" />
                )
            }
            {nameBtn}
        </button>
    )
}

export { ButtonActionsHL as default }